import React, { useEffect, useState } from 'react';
import { apiService } from 'utils/api';
import DetailsCard from 'components/logistics/user-profile-cards/details-card';
import { getSimpleDateFormat } from 'utils/functions';
import { Counter } from 'components/base/counter';
import { UserType } from 'models/user.model';
import useRoleContext from 'contexts/role.context';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

type UserProfileGeneralInfoProps = {
  user: UserType;
};

const UserProfileGeneralInfo = ({ user }: UserProfileGeneralInfoProps) => {
  const { role } = useRoleContext();
  const canUpdateFreeDeliveries = role !== ENUM_ROLE.LOGISTICS_ADMIN;

  const [count, setCount] = useState(+user.free_deliveries || 0);
  const [firstLoad, setFirstLoad] = useState(true);
  const updateFreeDeliveries = async () => {
    await apiService.post('logistics/user/update-free-deliveries', {
      data: { free_deliveries: count, user_id: user?.id },
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
  };

  useEffect(() => {
    if (!firstLoad) updateFreeDeliveries();
    setFirstLoad(false);
  }, [count]);

  return (
    <div className='grid md:grid-cols-2 gap-6'>
      <DetailsCard title='Mobile number'>
        <p>{user?.phone_number}</p>
      </DetailsCard>
      <DetailsCard title='Free deliveries'>
        <Counter count={count} setCount={setCount} disabled={!canUpdateFreeDeliveries} />
      </DetailsCard>

      <DetailsCard title='Email'>
        <p>{user?.email}</p>
      </DetailsCard>

      <DetailsCard title='Date of Birth'>
        <p>{`${getSimpleDateFormat(user?.dob)}`}</p>
      </DetailsCard>
    </div>
  );
};

export default UserProfileGeneralInfo;
